export const allowedOtpKeys = [
    49, 50, 51, 52, 53, 54, 55, 56, 57, 48, 8,
    96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 229
]